import { CheckBadgeIcon } from '@heroicons/react/16/solid';
import { useTranslation } from 'react-i18next';
import { eChannelType } from '../../../../../../providers/SocketsProvider/Sockets.enums.ts';
import { useChatContext } from '../../../../Chat.hook.ts';
import './AllowTypesBanner.styles.scss';

export default function AllowTypesBanner() {
  const { t } = useTranslation('chat/chat');
  const { showAllowTypesBanner, selectedChat } = useChatContext();

  return (
    <>
      {showAllowTypesBanner && (
        <div className="AllowTypesBanner">
          <CheckBadgeIcon className="AllowTypesBanner__Icon" />
          <div>
            {selectedChat?.integration === eChannelType.TIKTOK
              ? t('allowTypesBannerTiktok')
              : selectedChat?.integration === eChannelType.INSTAGRAM
                ? t('allowTypesBannerAlt1')
                : t('allowTypesBannerAlt2')}
          </div>
        </div>
      )}
    </>
  );
}
